import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a7122d18295d50014b89239_1787844047403_1b5ae3db/edurise/src/components/TransitionPage.tsx");
